// dependencies
import React from "react";
import { Link } from "yarrr";
import { Map } from "immutable";
import { format } from "date-fns";
import PropTypes from "prop-types";

// components
import Avatar from "Components/Avatar";
import BrowserLogo from "Components/BrowserLogo";

// style
import css from "./User";

export default class User extends React.Component {
	static propTypes = {
		user: PropTypes.instanceOf(Map).isRequired,
	};

	state = {
		isOpen: false,
	};

	handleOpenRequest = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	render = () => {
		const { user } = this.props;
		const { isOpen } = this.state;

		return (
			<div className={css.userWrapper}>
				<div className={css.topContainer}>
					<div className={css.userInformation}>
						<Avatar className={css.avatar} userID={user.get("id")} size={30} />
						<BrowserLogo
							className={`${css.browserLogo}`}
							size={15}
							name={user.getIn(["lastRequest", "userAgentParsed", "browser", "name"])}
						/>

						<div className={css.userName}>
							<Link href={`/breadcrumbs/${user.get("id")}/`}>{user.get("name")}</Link>
							<Link className={css.companyName} href={`/companies/${user.get("companyID")}/`}>
								{user.get("companyName")}
							</Link>
						</div>
					</div>

					<div onClick={this.handleOpenRequest} className={css.viewButton}>
						{isOpen ? "Close" : "View"}
					</div>
				</div>

				<div className={css.bottomContainer}>
					<div className={css.lastRequest}>{user.getIn(["lastRequest", "url"])}</div>
					<div className={`${css.time}`}>{format(user.get("startTime"), "MMM d, yyyy h:mm a")}</div>
				</div>

				{isOpen ? (
					<div className={css.verboseContainer}>
						<div className={css.prettyJSON}>{JSON.stringify(user.toJS(), null, 2)}</div>
					</div>
				) : null}
			</div>
		);
	};
}
